import React from "react";
import { imageBaseUrl } from "../../../../constants/ApiConstants";
import styled from "styled-components";
import { BsStarFill, BsStar } from "react-icons/bs";
import { getRelativeTime } from "../../../../utils/utils";

const DoctorReviewList = ({ reviews }) => {
  return (
    <div className="col mt-3">
      {reviews.map((review) => (
        <div className="row mb-3">
          <div className="d-flex gap-3 ">
            <img className="rounded-circle" style={{ objectFit: "cover", height: 60, width: 60 }} src={`${imageBaseUrl}${review.user.profile_image}`} />
            <div className="d-flex flex-column justify-content-around w-100">
              <div className="d-flex justify-content-between align-items-center w-100">
                <strong style={{ fontSize: 14 }}>{review.user.fullname}</strong>
                <span className="fs-sm text-grey2">{getRelativeTime(review.created_at)}</span>
              </div>
              <RatingWrapper>{Array.from({ length: 5 }, (_, index) => (index < Math.round(review.rating) ? <BsStarFill color={"orange"} key={index} /> : <BsStar color="orange" key={index} />))}</RatingWrapper>
              <span style={{ fontSize: 13 }} className="text-muted">
                {review.comment}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DoctorReviewList;
const RatingWrapper = styled.div`
  display: flex;
  gap: 0.2rem;
  p {
    font-size: 0.9rem;
    color: gray;
  }
  .ratingBold {
    font-size: 1.4rem;
  }
  .star {
    font-size: 20px;
    color: grey;
    margin-right: 5px;
    height: 12px;
  }

  .star.filled {
    color: orange;
  }
`;
